import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProviderModel } from '../../models/provider-model/provider-model';

@Injectable({
  providedIn: 'root'
})
export class ProvidersService {
  private apiUrl = environment.apiEndpoint + '/Provider';

  constructor(private http: HttpClient) { }

  getProviders(): Observable<ProviderModel[]> {
    return this.http.get<ProviderModel[]>(this.apiUrl);
  }

  createProvider(provider: Partial<ProviderModel>): Observable<ProviderModel> {
    return this.http.post<ProviderModel>(this.apiUrl, provider);
  }

  deleteProvider(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
